import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import axios from 'axios';

// @provider
// import { ImageLoadQueueProvider } from "@context/ImageLoadQueue";

// Redux Store
import { Provider } from 'react-redux';
import storeConfig from "@core/redux/storeConfig/store";

// @Utility
// import apiDomain from "@utility/app/apiDomain";

// Cache App component
// const MemoizedApp = React.memo(App); // ✅ Cache ตรงนี้

const store = storeConfig();
// const apiUrl = process.env?.REACT_APP_API_URL;
// axios.defaults.baseURL = apiUrl || apiDomain(window.location.host);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      {/* <ImageLoadQueueProvider batchSize={10}> */}
      <App />
      {/* </ImageLoadQueueProvider> */}
    </React.StrictMode>
  </Provider>
);

reportWebVitals();
